import React from 'react'
import { useFormik } from 'formik'
import enGB from "date-fns/locale/en-GB"
import ja from "date-fns/locale/ja"
import zhCN from "date-fns/locale/zh-CN"
import zhTW from "date-fns/locale/zh-TW"
import DatePicker, { registerLocale } from "react-datepicker";
import moment from 'moment'
import "react-datepicker/dist/react-datepicker.css"


const BookingForm = ({ bookingUrl, bookingData, id, pid, multiProperty, onClose, locale }) => {

  let bookingText = "Unavailable"
  switch (locale) {
    case "en":
      bookingText = "Unavailable";
      registerLocale("en", enGB);
    case "zhCN":
      bookingText = "Unavailable";
      registerLocale("zhCN", zhCN);
    case "zhTW":
      bookingText = "Unavailable";
      registerLocale("zhTW", zhTW);
    case "ja":
      bookingText = "Unavailable";
      registerLocale("ja", ja);
  }

  const getDateFormat = () => {
    if (locale === "en") {
      return "dd/MM/yyyy";
    } else {
      return "yyyy年 MM月 dd日";
    }
  };

  let initialValues = {      
    dateValues: {
      checkIn: moment().add(1, 'month').toDate(),
      checkOut: moment().add(34, 'days').toDate()
    },
    dateRangeStart: '20241201',
    singleDateStart: '12'
  }

  if (!!bookingData && !!bookingData.checkIn) {
    initialValues = {
      dateValues: {
        checkIn: moment(bookingData.checkIn).toDate(),
        checkOut: moment(bookingData.checkOut).toDate()
      },
      dateRangeStart: moment(bookingData.checkIn).format('YYYYMMDD'),
      singleDateStart: moment(bookingData.checkIn).format('MM')
    }
  }

  const formik = useFormik({
    initialValues: initialValues.dateValues,
    onSubmit: values => {
      const checkIn = moment(values.checkIn);
      const formattedCheckIn = checkIn.format('YYYYMMDD');
      const numberOfDays = moment(values.checkOut).diff(checkIn, 'days');
      return window.open(`${bookingUrl}&n=${numberOfDays}&ci=${formattedCheckIn}`, '_blank');
    }
  });

  const setCheckInDate = (e, form) => {
    const checkOutDate = moment(form.values.checkOut);
    const checkInDate = moment(e);
    if (checkOutDate.isBefore(checkInDate)) {
      form.setFieldValue('checkOut', checkInDate.add(1, 'day').toDate());
      return form.setFieldValue('checkIn', e);
    }
    return form.setFieldValue('checkIn', e);
  }

  const renderAvailability = () => {
    const rbId = !!pid ? pid : id;
    if (multiProperty) {
      return (
        <>
        <rb-daily-availability  lang="en" vid={ id } start={ initialValues.dateRangeStart } days="30" show-name="true"></rb-daily-availability>
        <div class="unavailable-wrapper">
        <div class="unavailable"></div>
        <span>{bookingText}</span>
        </div>
      </>
      )
    }
    return (
      <>
      <rb-sigcal fill="false" lang="en" mt={ initialValues.singleDateStart } cid="f808ad9646a175870146ad74bdf328d2" pid={ rbId }></rb-sigcal>
        <div class="unavailable-wrapper">
          <div class="unavailable"></div>
          <span>{bookingText}</span>
        </div>
      </>
    );
  }

  return (
    <div className="booking-form-container container content" onClick={ (e) => e.stopPropagation() }>
      <div onClick={() => onClose()} className="services-close desktop--hide">+</div>
      <form onSubmit={formik.handleSubmit} >
        <div className="form-field-wrapper date">
          <div className="date-wrapper">
            <label htmlFor="checkIn">Check in</label>
            <DatePicker
              id="checkIn"
              dateFormat={getDateFormat()}
              name="checkIn"
              onFocus={e => e.target.blur()}
              minDate={moment().toDate()}
              className="date-form-field form-field"
              selected={formik.values.checkIn}
              onChange={(e) => setCheckInDate(e, formik)}
            />
          </div>
          <div className="date-wrapper">
            <label htmlFor="checkOut">Check out</label>
            <DatePicker
              id="checkOut"
              dateFormat={getDateFormat()}
              name="checkOut"
              popperPlacement="bottom-end"
              onFocus={e => e.target.blur()}
              minDate={moment(formik.values.checkIn).add(1, 'day').toDate()}
              className="date-form-field form-field"
              selected={formik.values.checkOut}
              onChange={(e) => formik.setFieldValue("checkOut", e)}
            />
          </div>
          <div className="button-container">
          <button className="btn btn-main" type="submit">Search</button>
        </div>
        </div> 

        { renderAvailability() }

      </form>
    </div>
  );
}

export default BookingForm;